import { render, staticRenderFns } from "./unreadTopic.vue?vue&type=template&id=5958ee11"
import script from "./unreadTopic.vue?vue&type=script&lang=js"
export * from "./unreadTopic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/francescobarbieri/Dev/brain/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5958ee11')) {
      api.createRecord('5958ee11', component.options)
    } else {
      api.reload('5958ee11', component.options)
    }
    module.hot.accept("./unreadTopic.vue?vue&type=template&id=5958ee11", function () {
      api.rerender('5958ee11', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/admin-panel/components/topbar/unreadTopic.vue"
export default component.exports